// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__xr0Sx","spin":"spinner_spin__0JfTa"};